// extracted by mini-css-extract-plugin
export default {"root":"ConfirmDeleteModal_root__KzHpp","container":"ConfirmDeleteModal_container__RDQsp"};